import { memo } from "react"
import { ItemCell, ItemCellText } from "../InlineDrawer/StyleComponents"

export interface ItemBoxProps {
  item: {
    name: string
    color: string
    wrap?: boolean
  }
}

/**
 * Rendered only inside PopupComponent / PopupContainer, which already provide
 * the error boundary, theme and intl contexts. Do not re-wrap here: this is
 * mounted once per table cell and the extra providers dominate render cost.
 */
const ItemBox = ({ item }: ItemBoxProps) => {
  return (
    <ItemCell color={item.color}>
      <ItemCellText data-dark-tip={item.name} wrap={item.wrap}>
        {item.name}
      </ItemCellText>
    </ItemCell>
  )
}

export default memo(ItemBox)
